export default "__VITE_ASSET__Cqwdjwgq__"